//
//
//
//
export default {
  name: 'Logo'
};